import React, { memo, useCallback, useEffect, useState } from 'react';
import * as Styles from './style';
import Heading from 'components/Heading/Heading';
import { P } from 'components/reusable-css';
import { useTranslation } from 'react-i18next';
import CreateObject from './objects/CreateObject';
import SlidingPanels from 'components/common/sliding-panel';
import CreateObjectPanel from './objects/CreateObjectPanel';
import { useMediaQuery } from '@mui/material';
import { mutationProps } from 'utils/custom-hook';
import { Base64 } from 'js-base64';
import { useMutation, useQuery } from 'react-query';
import { CREATE_OBJECT } from './queries';
import ObjectsList from './objects/ObjectsList';
import axios from 'axios';
import { BASE_URL } from 'constants/env';

const ObjectTemplate = () => {
  const { t } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenCreateObj, setIsOpenCreateObj] = useState(false);
  const [label, setLabel] = useState('');
  const match = useMediaQuery('(max-width:550px)');
  const [createObj, setCreateObj] = useState({});
  const [objectArr, setObjectArr] = useState([]);
  const [isLoadingAll, setIsLoadingAll] = useState([]);
  const [objType, setObjType] = useState('ipv4');
  const { mutate: createObject, isLoading: createObjectLoading } = useMutation(CREATE_OBJECT);
  const { isLoading, refetch } = useQuery('/vs/firewall/object', {
    onSuccess: async (res) => {
      setIsLoadingAll(true);
      try {
        // Fetch all details for each id
        const promises = [];
        for (const key in res?.firewall_object) {
          const object = res?.firewall_object[key];
          const promise = await axios.get(`${BASE_URL}/vs/firewall/object/${object.id}`);
          promises.push({ ...object, list: promise.data });
        }
        await Promise.all(promises);
        setObjectArr(promises);
        setIsLoadingAll(false);
      } catch (error) {
        setIsLoadingAll(false);
      }
    },
  });

  const handleCreateRule = async (value) => {
    await createObject(
      {
        label: Base64.btoa(value),
        action: 'new',
        type: objType,
      },
      mutationProps(
        false,
        {
          onSuccess: async (res) => {
            await refetch();
            setIsOpenModal(false);
            setIsOpenCreateObj(true);
            setCreateObj(res);
          },
        },
        t,
      ),
    );
  };

  const handleNameSubmit = (value) => {
    const isValid = value.length != 0;
    if (isValid) {
      handleCreateRule(value);
    }
  };

  const handleCreateObjModal = (value) => {
    setIsOpenCreateObj(!isOpenCreateObj);
    if (value) setLabel('');
  };

  const escFunction = useCallback((event) => {
    if (event.key === 'Escape') {
      setIsOpenCreateObj(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const handleButtonClick = () => {
    setIsOpenModal(true);
    setLabel('');
    setObjType('ipv4');
  };

  return (
    <Styles.Step3SC>
      <Heading name={'vs/firewall.string41'} button buttonTxt={'vs/firewall.string42'} buttonCick={handleButtonClick}>
        <Styles.ObjectSC>
          <P>{t('vs/firewall.string50')}</P>
        </Styles.ObjectSC>
        <Styles.StepDescription />
        <ObjectsList objectArr={objectArr} isLoading={isLoading || isLoadingAll} mainRefetch={refetch} />
        {isOpenModal && (
          <CreateObject
            handleNameSubmit={handleNameSubmit}
            openFilter={isOpenModal}
            handleClose={() => setIsOpenModal(false)}
            isLoading={createObjectLoading}
            label={label}
            setLabel={setLabel}
            objType={objType}
            setObjType={setObjType}
          />
        )}
        {isOpenCreateObj && (
          <SlidingPanels size={match ? 93 : 50} isOpen={isOpenCreateObj} isClose={setIsOpenCreateObj}>
            <CreateObjectPanel
              mainRefetch={refetch}
              item={{ id: createObj?.item_id, type: objType }}
              label={label}
              handleCloseModal={handleCreateObjModal}
            />
          </SlidingPanels>
        )}
      </Heading>
    </Styles.Step3SC>
  );
};

export default memo(ObjectTemplate);
